import { ConfigBathroomModuleCase } from './domain/useCases/ConfigBathroomModuleCase'
import { ConfigFoodModuleCase } from './domain/useCases/ConfigFoodModuleCase'
import { ConfigLiquidModuleCase } from './domain/useCases/ConfigLiquidModuleCase'
import { ConfigPhotoModuleCase } from './domain/useCases/ConfigPhotoModuleCase'
import { ConfigRemedyModuleCase } from './domain/useCases/ConfigRemedyModuleCase'
import { ConfigSleepModuleCase } from './domain/useCases/ConfigSleepModuleCase'
import { GetConfigModulesCase } from './domain/useCases/GetConfigAllModulesCase'
import { clientConfigDatasourceAdapter } from './external/configClientModuleDatasourceAdapter'
import { configClientRepositoryAdapter } from './infra/configClientRepositoryAdapter'

const sleepConfig = ConfigSleepModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const remedyConfig = ConfigRemedyModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const foodConfig = ConfigFoodModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const liquidConfig = ConfigLiquidModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const bathroomConfig = ConfigBathroomModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const photoConfig = ConfigPhotoModuleCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)
const getModuleConfig = GetConfigModulesCase(
  configClientRepositoryAdapter(clientConfigDatasourceAdapter)
)

export const configClientModuleInstance = {
  sleepConfig: sleepConfig,
  updateSleepConfig: sleepConfig,
  remedyConfig: remedyConfig,
  updateRemedyConfig: remedyConfig,
  liquidConfig: liquidConfig,
  updateLiquidConfig: liquidConfig,
  foodConfig: foodConfig,
  updateFoodConfig: foodConfig,
  bathroomConfig: bathroomConfig,
  updateBathroomConfig: bathroomConfig,
  getModuleConfig: getModuleConfig,
  photoConfig: photoConfig,
  updatePhotoConfig: photoConfig
}
